import get from 'lodash/get';
import { modifyAlpha } from '../../../../../utils/modifyColour';

const styles = ({ color, theme, typography }) => ({
  badge: {
    backgroundColor: modifyAlpha(get(color, 'primaryButtonBackground'), '0.08'),
    right: -20,
    top: 8,
  },
  categoryBox: {
    border: `6px solid ${get(color, 'background')}`,
    borderLeft: 'none',
    borderRight: 'none',
    marginLeft: -36,
    marginRight: -20,
  },
  complianceBtnsGroup: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  categoryConfigsList: {
    display: 'flex',
    listStyleType: 'None',
    marginBottom: 10,
    marginLeft: 8,
    marginTop: 10,

    paddingLeft: 0,
    '& li:not(:first-child)': {
      paddingLeft: 4,
    },
    '& li': {
      paddingLeft: 0,
      paddingRight: 0,
      '&:not(:last-child)::after': {
        color: get(color, 'bodyText'),
        content: '"  •"',
      },
    },
  },
  categoryHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  categoryHeaderCollapse: {
    marginLeft: 10,
    marginTop: 10,
    minWidth: 32,
    paddingLeft: 9,
    paddingRight: 9,
  },
  categoryHeaderCollapseDiv: {
    padding: 2,
  },
  categoryHeaderCollapseIcon: {
    marginLeft: 0,
    marginRight: 0,
  },
  categoryHeaderLeft: {
    display: 'flex',
  },
  categoryHelpTextContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  categorySubTitle: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 12,
    paddingRight: 12,
  },
  categoryTitle: {
    fontFamily: get(typography, 'siteTitle'),
    lineHeight: '40px',
  },
  categoryTitleBtns: {
    alignItems: 'flex-start',
    display: 'flex',
  },
  categoryWiseError: {
    display: 'flex',
  },
  categoryWiseErrorContainer: {
    display: 'flex',
  },
  chipError: {
    borderColor: get(color, 'error'),
    borderWidth: 2,
    color: get(color, 'error'),
    fontWeight: 700,
  },
  chipSuccess: {
    borderColor: get(color, 'green'),
    borderWidth: 2,
    color: get(color, 'green'),
    fontWeight: 700,
  },
  chipWarn: {
    borderColor: get(color, 'warning'),
    borderWidth: 2,
    color: get(color, 'warning'),
    fontWeight: 700,
  },
  complianceBtnsGroupContainer: {

  },
  complianceError: {
    color: get(color, 'error'),
    fill: get(color, 'error'),
  },
  complianceNoIssue: {
    color: get(color, 'green'),
    fill: get(color, 'green'),
  },
  complianceWarning: {
    color: get(color, 'warning'),
    fill: get(color, 'warning'),
  },
  disableDeleteIcon: {
    visibility: 'hidden',
  },
  fixedCategoryDragIcon: {
    visibility: 'hidden',
  },
  flexibleCategoryHeader: {
    cursor: 'pointer',
  },
  iconRoot: {
    marginTop: 4,
    color: get(theme, 'color.primaryButtonBackground'),
  },
  panelTitle: {
    color: get(theme, 'color.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    fontWeight: 700,
    padding: 7,
    paddingLeft: '12%',
  },
  policyLabel: {
    padding: '10px 0',
  },
  templatesMenuList: {
    maxHeight: 200,
    '@media (min-height: 480px)': {
      maxHeight: 300,
    },
    '@media (min-height: 720px)': {
      maxHeight: 360,
    },
  },
  popper: {
    zIndex: 1200,
  },
  titleStatusIcon: {
    alignItems: 'center',
    display: 'flex',
    marginLeft: 6,
    marginRight: 6,
  },
  titleStatusIconsContainer: {
    display: 'flex',
    height: 40,
  },
});

export default styles;